// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"User_wrapper__2IE_p","container":"User_container__10dm0"};